// Tedarikci (Supplier) API — /api/suppliers uclari.
import { logoRequest } from './client';
import { ensureSession } from './session';
import { Supplier, LogoResult } from '../types';

export interface SupplierFilter {
  onlyActive?: boolean;
  code?: string;
  title?: string;
  city?: string;
  countryCode?: string;
}

function toQuery(f: SupplierFilter = {}): Record<string, string | number | boolean> {
  const q: Record<string, string | number | boolean> = {};
  if (f.onlyActive !== undefined) q.OnlyActive = f.onlyActive;
  if (f.code) q.Code = f.code;
  if (f.title) q.Title = f.title;
  if (f.city) q.City = f.city;
  if (f.countryCode) q.CountryCode = f.countryCode;
  return q;
}

/** GET /api/suppliers */
export async function getSuppliers(filter: SupplierFilter = {}): Promise<LogoResult<Supplier[]>> {
  await ensureSession();
  return logoRequest<Supplier[]>({ url: '/api/suppliers', method: 'GET', params: toQuery(filter) });
}

/** GET /api/suppliers/{code} */
export async function getSupplier(code: string): Promise<LogoResult<Supplier>> {
  await ensureSession();
  return logoRequest<Supplier>({ url: `/api/suppliers/${encodeURIComponent(code)}`, method: 'GET' });
}

/** POST /api/suppliers — ekle/guncelle (insert icin id=0). */
export async function saveSupplier(supplier: Supplier): Promise<LogoResult<Supplier>> {
  await ensureSession();
  return logoRequest<Supplier>({ url: '/api/suppliers', method: 'POST', data: supplier });
}

/** POST /api/suppliers/bulk */
export async function saveSuppliersBulk(suppliers: Supplier[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest<unknown>({ url: '/api/suppliers/bulk', method: 'POST', data: suppliers });
}

/** DELETE /api/suppliers/{id} */
export async function deleteSupplier(id: number): Promise<LogoResult<void>> {
  await ensureSession();
  return logoRequest<void>({ url: `/api/suppliers/${id}`, method: 'DELETE' });
}
